import { Avatar, Box, Button, Typography } from '@wishket/design-system';
import { twJoin } from 'tailwind-merge';

import { Link } from '@/shared/Components';
import { PATH } from '@/shared/constants';

interface SearchedAuthorCardProps {
  name?: string;
  imgUrl?: string;
  description?: string;
  urlIdentifier?: string;
  isFixedSize?: boolean;
}

const AuthorProfileLinkCard = ({
  name,
  imgUrl,
  description,
  urlIdentifier,
  isFixedSize = false,
}: SearchedAuthorCardProps) => {
  return (
    <Box
      className={twJoin(
        'flex min-w-[180px] max-w-[232px] flex-col items-center gap-4 rounded-3xl bg-w-gray-10 p-6',
        isFixedSize ? 'w-[210px] shrink-0' : 'w-full'
      )}
      data-testid="author-profile-link-card"
    >
      <Avatar size="lg" imgUrl={imgUrl} />
      <Box className="flex flex-col items-center gap-1.5">
        <Typography variant="body1" className="font-medium text-w-gray-900">
          {name}
        </Typography>
        <Typography variant="body2" className="text-w-gray-700">
          {description}
        </Typography>
      </Box>
      <Link href={`${PATH.HOME}/@${urlIdentifier}`} className="w-full">
        <Button variant="solid" size="sm" className="w-full">
          작가 프로필 보기
        </Button>
      </Link>
    </Box>
  );
};

export default AuthorProfileLinkCard;
